import * as tslib_1 from "tslib";
import { all as mergeAll } from 'deepmerge';
import { SearchMaskGroupType, SearchMaskInputType, } from '../../globalTypes';
var UserQueryCreator = /** @class */ (function () {
    function UserQueryCreator() {
    }
    UserQueryCreator.create = function (lturState, searchMaskGroupType, optionalQueries) {
        if (searchMaskGroupType === void 0) { searchMaskGroupType = SearchMaskGroupType.PACKAGE; }
        if (optionalQueries === void 0) { optionalQueries = null; }
        if (!lturState
            || !lturState.websiteState
            || !lturState.websiteState.searchMask.searchMaskBundle
            || !lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType]) {
            return {};
        }
        var inputGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        if (inputGroup) {
            var options_1 = {
                customMerge: function (key) {
                    if (key === 'PRODUCT_GROUPS') {
                        return function (valueA, valueB) { return valueB; };
                    }
                }
            };
            return Object.keys(inputGroup.inputs).reduce(function (accumulator, currentInputKey) {
                var inputQuery = (inputGroup && inputGroup.inputs[currentInputKey].coreQuery ? tslib_1.__assign({}, inputGroup.inputs[currentInputKey].coreQuery) : {});
                var optionalQuery = null;
                if (optionalQueries) {
                    var filteredOptionalQueries = optionalQueries.filter(function (query) { return query.type === currentInputKey; });
                    if (filteredOptionalQueries && filteredOptionalQueries.length > 0) {
                        optionalQuery = filteredOptionalQueries[0];
                    }
                }
                var optQuery = ((optionalQuery && optionalQuery.type === currentInputKey && optionalQuery.coreQuery) ? tslib_1.__assign({}, optionalQuery.coreQuery) : {});
                return mergeAll([accumulator, inputQuery, optQuery], options_1);
            }, {});
        }
        return {};
    };
    UserQueryCreator.createAppUrl = function (lturState, searchMaskGroupType, resetStateParams) {
        if (searchMaskGroupType === void 0) { searchMaskGroupType = SearchMaskGroupType.PACKAGE; }
        if (!lturState
            || !lturState.websiteState
            || !lturState.websiteState.searchMask.searchMaskBundle
            || !lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType]) {
            return {};
        }
        var inputGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
        var websiteState = lturState.websiteState;
        if (inputGroup && websiteState) {
            var result_1 = {};
            return Object.keys(inputGroup.inputs).reduce(function (accumulator, currentInputKey) {
                if (currentInputKey === SearchMaskInputType.TRAVEL_PERIOD) {
                    if (inputGroup.inputs[currentInputKey].confirmedValue.value.exactDepartureDate) {
                        result_1.exactDepartureDate = 1;
                    }
                    else {
                        // @ts-ignore
                        delete result_1.exactDepartureDate;
                    }
                    if (inputGroup.inputs[currentInputKey].confirmedValue.value.exactDuration) {
                        result_1.exactDuration = 1;
                    }
                    else {
                        // @ts-ignore
                        delete result_1.exactDuration;
                    }
                    if (!resetStateParams && inputGroup.inputs[currentInputKey].confirmedValue.value.preferredDepartureDate) {
                        result_1.preferredDepartureDate = inputGroup.inputs[currentInputKey].confirmedValue.value.preferredDepartureDate;
                    }
                    else {
                        // @ts-ignore
                        delete result_1.preferredDepartureDate;
                    }
                }
                if (currentInputKey === SearchMaskInputType.FLEX) {
                    if (inputGroup.inputs[currentInputKey].confirmedValue.value) {
                        result_1.flex = 1;
                    }
                    else {
                        delete result_1.flex;
                    }
                }
                return result_1;
            }, {});
        }
        return {};
    };
    return UserQueryCreator;
}());
export { UserQueryCreator };
export default UserQueryCreator;
